import React from 'react'
import { Icon } from '../../../../../atoms/Icon'
import { InfoTooltip } from '../../../../../InfoTooltip'
import { TooltipMetricExplanation } from '../../../../../TooltipMetricExplanation'
import { Badge } from '../../../../../atoms/Badge'
import {
  Card,
  CardHeader,
  CardTitle,
  MetricGrid,
  MetricRow,
  MetricLabel,
  MetricValue,
  MetricHighlight,
} from '../../../BuildingCharacteristics.styles'
import type { NeighborhoodAnalysisCardProps } from '../NeighborhoodContextTab.types'

export const NeighborhoodAnalysisCard: React.FC<
  NeighborhoodAnalysisCardProps
> = ({ neighborhoodAnalysis, buildingConformity, t }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <Icon name="home" size="small" />
          {t('neighborhood.cards.neighborhoodAnalysis.title')}
          <InfoTooltip>
            <TooltipMetricExplanation
              title={t('neighborhood.cards.neighborhoodAnalysis.tooltip.title')}
              shortDescription={t(
                'neighborhood.cards.neighborhoodAnalysis.tooltip.description'
              )}
              calculation={t(
                'neighborhood.cards.neighborhoodAnalysis.tooltip.calculation'
              )}
              importance={t(
                'neighborhood.cards.neighborhoodAnalysis.tooltip.importance'
              )}
              source={t('neighborhood.cards.analysis.tooltip.source')}
            />
          </InfoTooltip>
        </CardTitle>
        {buildingConformity &&
          neighborhoodAnalysis.quartier_analysis.quartier_score >= 70 &&
          buildingConformity.score < 40 && (
            <Badge variant="danger">
              {t('neighborhood.badges.buildingOutlier')}
            </Badge>
          )}
      </CardHeader>
      <MetricGrid>
        <MetricRow>
          <MetricLabel>
            {t('neighborhood.metrics.neighborhoodCohesion')}
          </MetricLabel>
          <MetricHighlight
            $type={
              neighborhoodAnalysis.quartier_analysis.quartier_score >= 70
                ? 'success'
                : neighborhoodAnalysis.quartier_analysis.quartier_score >= 40
                  ? 'warning'
                  : 'danger'
            }
            $textAlign="right"
          >
            {neighborhoodAnalysis?.quartier_analysis?.quartier_score?.toFixed(
              1
            )}
            /100
          </MetricHighlight>
        </MetricRow>
        {buildingConformity && (
          <MetricRow>
            <MetricLabel>
              {t('neighborhood.metrics.buildingConformity')}
            </MetricLabel>
            <MetricHighlight
              $type={
                buildingConformity.score >= 70
                  ? 'success'
                  : buildingConformity.score >= 40
                    ? 'warning'
                    : 'danger'
              }
              $textAlign="right"
            >
              {buildingConformity.score.toFixed(1)}/100
            </MetricHighlight>
          </MetricRow>
        )}
        <MetricRow>
          <MetricLabel>{t('neighborhood.metrics.confidence')}</MetricLabel>
          <MetricValue style={{ textTransform: 'capitalize' }}>
            {neighborhoodAnalysis.quartier_analysis.confidence}
          </MetricValue>
        </MetricRow>
        <MetricRow>
          <MetricLabel>
            {t('neighborhood.metrics.buildingsAnalyzed')}
          </MetricLabel>
          <MetricValue>{neighborhoodAnalysis.building_count}</MetricValue>
        </MetricRow>
      </MetricGrid>
      {buildingConformity &&
        neighborhoodAnalysis.quartier_analysis.quartier_score >= 70 &&
        buildingConformity.score < 40 && (
          <div
            style={{
              padding: '12px 16px',
              marginTop: '12px',
              backgroundColor: '#fff3cd',
              borderLeft: '4px solid #ffc107',
              fontSize: '13px',
              color: '#856404',
            }}
          >
            <strong>{t('neighborhood.warnings.outlierTitle')}</strong>{' '}
            {t('neighborhood.warnings.outlierDescription')}
          </div>
        )}
    </Card>
  )
}
